import React, { useState } from 'react'
import { useLocation } from 'react-router-dom';
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import AddIcon from '@material-ui/icons/Add';
import CreateIcon from '@material-ui/icons/Create';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CropLandscapeIcon from '@material-ui/icons/CropLandscape';
import AddClient from '../Clients/AddClient';
import AddVendor from '../Vendors/AddVendor';
import AddMetal from '../Metals/AddMetal';

const FabButton = () => {

  const location = useLocation()
  const mainButtonStyles = {backgroundColor: '#1976D2'}
  const [open, setOpen] = useState(false)
  const [openVendor, setOpenVendor] = useState(false)
  const [openMetal, setOpenMetal] = useState(false)


  // if(location.pathname === '/invoice') return null

    return (
        <div>
           <AddClient setOpen={setOpen} open={open} />
           <AddVendor setOpenVendor={setOpenVendor} openVendor={openVendor} />
           <AddMetal setOpenMetal={setOpenMetal} openMetal={openMetal} />
          <Fab
            mainButtonStyles={mainButtonStyles}
            icon={ <AddIcon />}
            alwaysShowTitle={true}
          >

            {location.pathname !== '/invoice' && (
              <Action
                  text="New Invoice"
                  // onClick={() =>  history.push(`/invoice`)}
                  onClick={() => window.location.href='/invoice'}
                >
                  <CreateIcon />
              </Action>
            )}

            <Action
                text="New Customer"
                onClick={() => setOpen((prev) => !prev)}
              >
                <PersonAddIcon />
            </Action>

            <Action
                text="New Vendor"
                onClick={() => setOpenVendor((prev) => !prev)}
              >
                <PersonAddIcon />
            </Action>

            <Action
                text="New Metal"
                onClick={() => setOpenMetal((prev) => !prev)}
              >
                <CropLandscapeIcon />
            </Action>

            <Action
                text="New Inventory"
                onClick={() => window.location.href='/inventory'}
              >
                <CropLandscapeIcon />
            </Action>

          </Fab>
        </div>
    )
}

export default FabButton
